import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { Header } from 'src/app/utils/interfaces/new/header.interface';

@Component({
  selector: 'app-mss-menu',
  templateUrl: './mss-menu.component.html',
  styleUrls: ['./mss-menu.component.scss']
})
export class MSSMenuComponent implements OnInit, OnDestroy {

  activeFor = 'releves';

  private _navigationSub: Subscription;

  constructor(
    public router: Router,
    private _send: HeaderCommunicationService
  ) {
    const head: Header = {
      isBack: true,
      title: 'Messagerie Sécurisée de Santé',
      backPage: 'home',
    };
    this._send.announceHeader(head);

    /**
     * Ce subscribe permet de savoir si on est dans la page '/user/messagerie' lors d'une navigation
     * Si c'est le cas, alors on réinitialise le head de navigation
     * afin que le bouton de retour nous renvoi vers la page souhaitée.
     */
    this._navigationSub = router.events.subscribe((evt: any) => {
      if (evt instanceof NavigationEnd) {
        if (evt.url === '/user/messagerie') {
          this._send.announceHeader(head);
        }
      }
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
      if (this._navigationSub) {
        this._navigationSub.unsubscribe();
      }
  }

  public routeTo(event: any, routeInfo: string): void {
    event.preventDefault();
    this.router.navigateByUrl(`/user/messagerie/${routeInfo}`);
  }
}
